import React from 'react';

import { H2, HeroBackground, BodyLargeText } from 'playful-ui';

import { App, Helmet } from 'modules/app';
import { MainNavigation } from 'modules/navigation';
import { WorkshopsPage } from 'modules/experience';
import na_podu from 'modules/experience/assets/sq/4na_podu_sq.jpg';

export default class Workshop extends React.Component {
  render() {
    return (
      <App>
        <Helmet
          route={WorkshopsPage.route}
          title={WorkshopsPage.title}
          image={na_podu}
        />
        <MainNavigation />
        <HeroBackground textual>
          <H2>STEMI radionice</H2>
          <BodyLargeText>
            Prijavi se na STEMI Lab radionice te uz mentorstvo STEMI edukatora i
            inženjera postani član našeg tima! Uz timski rad i zabavu uči o
            tehnologijama budućnosti: 3D modeliranje i printanje, izrada
            vlastite mobilne aplikacije, programiranje i robotika općenito.
          </BodyLargeText>
        </HeroBackground>
        <WorkshopsPage />
      </App>
    );
  }
}
